import { Button, Container, Group } from '@chakra-ui/react'
import { GITHUB_URL } from '@src/constant'
import { lang } from '@src/lang'
import { LuGithub, LuMail } from 'react-icons/lu'
import './Header.css'

export const Header = () => {
    const handleGithubClick = () => {
        window.open(GITHUB_URL, '_blank')
    }

    return (
        <header className="site-header">
            <Container fluid paddingInline={6} paddingBlock={6}>
                <div className="site-header__row">
                    <a
                        className="site-header__brand"
                        href="https://yandex.cloud/ru/social-tech"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img
                            className="site-header__logo"
                            src="/brand/yandex-cloud.svg"
                            alt="Yandex Cloud"
                            width="212"
                            height="30"
                        />
                        <span className="site-header__centre">
                            Центр технологий<br />для общества
                        </span>
                    </a>
                    <div className="site-header__project">
                        <h1 className="site-header__title">Чистый берег</h1>
                        <p className="site-header__description">{lang.headerDescription}</p>
                    </div>
                    <Group className="site-header__actions">
                        <Button onClick={handleGithubClick}>
                            <LuGithub /> {lang.github}
                        </Button>
                        <Button>
                            <LuMail /> {lang.mail}
                        </Button>
                    </Group>
                </div>
            </Container>
        </header>
    )
}
